import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import resumeEntries from "./resumeData";
import resumeStyles from "./resumeStyles";

const Resume = () => {
  return (
    <Box component="header" sx={resumeStyles.section}>
      <Typography variant="h4" align="center" sx={resumeStyles.heading}>
        Working Experience
      </Typography>
      <Box component="div" sx={resumeStyles.timeline}>
        {resumeEntries.map((entry, index) => {
          const isRight = index % 2 === 1;
          return (
          <React.Fragment key={entry.year}>
            <Typography variant="h2" sx={resumeStyles.year}>
              {entry.year}
            </Typography>
            <Box
              component="div"
              sx={[resumeStyles.item, isRight ? resumeStyles.itemRight : resumeStyles.itemLeft]}
            >
              <Typography variant="h5" align="center" sx={resumeStyles.title}>
                {entry.title}
              </Typography>
              <Typography
                variant="body1"
                align="center"
                sx={resumeStyles.company}
              >
                {entry.company}
              </Typography>
              <Typography
                variant="subtitle1"
                align="center"
                sx={resumeStyles.description}
              >
                {entry.description}
              </Typography>
            </Box>
          </React.Fragment>
        );
        })}
      </Box>
    </Box>
  );
};

export default Resume;
